
<button mat-raised-button color="primary" (click)="search()">Lookup Postcode <fa-icon matSuffix [icon]="faSearch" ></fa-icon></button>

